// import './scss2/reset.scss';
import React from 'react';
import { createRoot } from 'react-dom/client'; // 변경된 임포트

import './index.scss';

import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
// import {store2} from './store';
import { store2, persistor } from './store'; // Redux Persist 설정 추가
import { PersistGate } from 'redux-persist/integration/react'; // PersistGate 추가


const root = createRoot(document.getElementById('root')); // createRoot 사용
root.render(
  // <React.StrictMode>
    <Provider store={store2}>
    {/* PersistGate로 감싸서 상태 복원 */}
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);
